import {
  LIBRARY_TAXES_PAGE_REQUEST,
  LIBRARY_TAXES_LIST_REQUEST,
  LIBRARY_TAXES_SET_LIST_TAXES,
  LIBRARY_TAXES_ON_CHANGE_OUTLET_IDS,
  LIBRARY_TAXES_SET_OUTLETS,
  LIBRARY_TAXES_ON_CLICK_CREATE_TAX,
  LIBRARY_TAXES_SET_CURRENT_PAGE,
  LIBRARY_TAXES_SET_TOTAL_PAGE,
  LIBRARY_TAXES_ON_CLICK_ROW,
  LIBRARY_TAXES_SET_TAX_DETAIL,
  LIBRARY_TAXES_ON_CLICK_CANCEL,
  LIBRARY_TAXES_SUBMIT_FORM_UPDATE,
  LIBRARY_TAXES_SUBMIT_FORM_CREATE,
  LIBRARY_TAXES_DELETE_TAX_REQUEST,
  LIBRARY_TAXES_SHOW_DELETE_MODAL,
  LIBRARY_TAXES_HIDE_DELETE_MODAL,
  LIBRARY_TAXES_CANCEL_DELETE,
  LIBRARY_TAXES_DELETE_TAX,
  LIBRARY_TAXES_SET_DELETED_TAX,
  LIBRARY_TAXES_SUBMIT_FORM_CREATE_ALL_OUTLETS,
  LIBRARY_TAXES_CLOSE_RIGHT_COLUMN,
  LIBRARY_TAXES_OPEN_RIGHT_COLUMN,
  LIBRARY_TAXES_IS_SUBMITTING_FORM,
  LIBRARY_TAXES_SHOW_TAX_ASSIGN_TO_ITEM_MODAL,
  LIBRARY_TAXES_HIDE_TAX_ASSIGN_TO_ITEM_MODAL,
  LIBRARY_TAXES_ON_CLICK_TAX_ASSIGN_TO_ITEM,
  LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_FILL_FORM,
  LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_SET_ITEMS,
  LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_SET_CURRENT_PAGE,
  LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_SET_TOTAL_PAGE,
  LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_SET_TOTAL_COUNT,
  LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_ITEMS_REQUEST,
  LIBRARY_TAXES_CANCEL_TAX_ASSIGN_TO_ITEM,
  LIBRARY_TAXES_CONFIRM_TAX_ASSIGN_TO_ITEM,
  LIBRARY_TAXES_SET_CATEGORY_LIST,
  LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_SELECT_ALL_NONE,
  LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_TOGGLE_ONE,
  LIBRARY_TAXES_SET_SETTING,
  LIBRARY_TAXES_CHECK_SELECT_ALL_TAX_ITEMS,
  LIBRARY_TAXES_UNCHECK_SELECT_ALL_TAX_ITEMS,
  LIBRARY_TAXES_SHOW_SAVE_TO_ALL_OUTLETS_MODAL,
  LIBRARY_TAXES_HIDE_SAVE_TO_ALL_OUTLETS_MODAL,
  LIBRARY_TAXES_SET_CREATED_OUTLETS
} from './constants'

export function showTaxAssignToItemModal () {
  return {type: LIBRARY_TAXES_SHOW_TAX_ASSIGN_TO_ITEM_MODAL, payload: {}}
}

export function hideTaxAssignToItemModal () {
  return {type: LIBRARY_TAXES_HIDE_TAX_ASSIGN_TO_ITEM_MODAL, payload: {}}
}

export function onClickTaxAssignToItem (tax, categoryId) {
  return {type: LIBRARY_TAXES_ON_CLICK_TAX_ASSIGN_TO_ITEM, payload: {tax, categoryId}}
}

export function taxAssignToItemFillForm (tax, categoryId) {
  if (!categoryId) {
    categoryId = 0
  }
  return {type: LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_FILL_FORM, payload: {tax, categoryId}}
}

export function taxAssignToItemSetItems (items) {
  return {type: LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_SET_ITEMS, payload: {items}}
}

export function taxAssignToItemSetCurrentPage (currentPage) {
  return {type: LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_SET_CURRENT_PAGE, payload: {currentPage}}
}

export function taxAssignToItemSetTotalPage (totalPage) {
  return {type: LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_SET_TOTAL_PAGE, payload: {totalPage}}
}

export function taxAssignToItemSetTotalCount (totalCount) {
  return {type: LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_SET_TOTAL_COUNT, payload: {totalCount}}
}

export function taxAssignToItemItemsRequest (params, previousItems) {
  return {type: LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_ITEMS_REQUEST, payload: {params, previousItems}}
}

export function cancelTaxAssignToItem (taxDetail, url) {
  return {type: LIBRARY_TAXES_CANCEL_TAX_ASSIGN_TO_ITEM, payload: {taxDetail, url}}
}

export function confirmTaxAssignToItem (taxDetail, tax) {
  return {type: LIBRARY_TAXES_CONFIRM_TAX_ASSIGN_TO_ITEM, payload: {taxDetail, tax}}
}

export function taxAssignToItemSelectAllNone (businessId, outletId, taxDetail, itemIds, categoryId, keyword, selectAll) {
  return {type: LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_SELECT_ALL_NONE, payload: {businessId, outletId, taxDetail, itemIds, categoryId, keyword, selectAll}}
}

export function taxAssignToItemToggleOne (taxDetail, item, add) {
  return {type: LIBRARY_TAXES_TAX_ASSIGN_TO_ITEM_TOGGLE_ONE, payload: {taxDetail, item, add}}
}

export function setSetting (setting) {
  return {type: LIBRARY_TAXES_SET_SETTING, payload: {setting}}
}

export function showSaveToAllOutletsModal () {
  return {type: LIBRARY_TAXES_SHOW_SAVE_TO_ALL_OUTLETS_MODAL, payload: {}}
}

export function hideSaveToAllOutletsModal () {
  return {type: LIBRARY_TAXES_HIDE_SAVE_TO_ALL_OUTLETS_MODAL, payload: {}}
}

export function checkSelectAllTaxItems () {
  return {type: LIBRARY_TAXES_CHECK_SELECT_ALL_TAX_ITEMS, payload: {}}
}

export function uncheckSelectAllTaxItems () {
  return {type: LIBRARY_TAXES_UNCHECK_SELECT_ALL_TAX_ITEMS, payload: {}}
}

export function setCategories (categories) {
  return {type: LIBRARY_TAXES_SET_CATEGORY_LIST, payload: {categories}}
}

export function setCreatedOutlets (createdOutlets) {
  return {type: LIBRARY_TAXES_SET_CREATED_OUTLETS, payload: {createdOutlets}}
}

export function taxesPageRequest () {
  return {type: LIBRARY_TAXES_PAGE_REQUEST, payload: {}}
}

export function taxesRequest (params, previousTaxes) {
  return {type: LIBRARY_TAXES_LIST_REQUEST, payload: {params, previousTaxes}}
}

export function setListTaxes (taxes) {
  return {type: LIBRARY_TAXES_SET_LIST_TAXES, payload: {taxes}}
}

export function onChangeOutletIds (outletIds) {
  return {type: LIBRARY_TAXES_ON_CHANGE_OUTLET_IDS, payload: {outletIds: outletIds}}
}

export function setOutlets (outlets) {
  return {type: LIBRARY_TAXES_SET_OUTLETS, payload: {outlets}}
}

export function setCurrentPage (currentPage) {
  return {type: LIBRARY_TAXES_SET_CURRENT_PAGE, payload: {currentPage}}
}

export function setTotalPage (totalPage) {
  return {type: LIBRARY_TAXES_SET_TOTAL_PAGE, payload: {totalPage}}
}

export function onClickCreateTax () {
  return {type: LIBRARY_TAXES_ON_CLICK_CREATE_TAX, payload: {}}
}

export function onClickRow (tax) {
  return {type: LIBRARY_TAXES_ON_CLICK_ROW, payload: {tax}}
}

export function setTaxDetail (tax) {
  return {type: LIBRARY_TAXES_SET_TAX_DETAIL, payload: {tax}}
}

export function onClickCancel () {
  return {type: LIBRARY_TAXES_ON_CLICK_CANCEL, payload: {}}
}

export function submitFormUpdate (id, data, previousTaxes, itemIds, selectedOutletIds, outlets) {
  return {type: LIBRARY_TAXES_SUBMIT_FORM_UPDATE, payload: {id, data, previousTaxes, itemIds, selectedOutletIds, outlets}}
}

export function submitFormCreate (data, previousTaxes, itemIds, selectedOutletIds, outlets) {
  return {type: LIBRARY_TAXES_SUBMIT_FORM_CREATE, payload: {data, previousTaxes, itemIds, selectedOutletIds, outlets}}
}

export function setDeletedTax (deletedTax) {
  return {type: LIBRARY_TAXES_SET_DELETED_TAX, payload: {deletedTax}}
}

export function deleteTaxRequest (deletedTax) {
  return {type: LIBRARY_TAXES_DELETE_TAX_REQUEST, payload: {deletedTax}}
}

export function showDeleteModal () {
  return {type: LIBRARY_TAXES_SHOW_DELETE_MODAL, payload: {}}
}

export function hideDeleteModal () {
  return {type: LIBRARY_TAXES_HIDE_DELETE_MODAL, payload: {}}
}

export function cancelDelete () {
  return {type: LIBRARY_TAXES_CANCEL_DELETE, payload: {}}
}

export function deleteTax (id, previousTaxes, taxDetail, categories) {
  return {type: LIBRARY_TAXES_DELETE_TAX, payload: {id, previousTaxes, taxDetail, categories}}
}

export function submitFormCreateAllOutlets (data, previousTaxes, itemIds, selectedOutletIds, outlets) {
  return {type: LIBRARY_TAXES_SUBMIT_FORM_CREATE_ALL_OUTLETS, payload: {data, previousTaxes, itemIds, selectedOutletIds, outlets}}
}

export function openRightColumn () {
  return {type: LIBRARY_TAXES_OPEN_RIGHT_COLUMN, payload: {}}
}

export function closeRightColumn () {
  return {type: LIBRARY_TAXES_CLOSE_RIGHT_COLUMN, payload: {}}
}

export function isSubmittingForm (isSubmittingForm) {
  return {type: LIBRARY_TAXES_IS_SUBMITTING_FORM, payload: {isSubmittingForm}}
}



// WEBPACK FOOTER //
// ./app/actions/library/tax/index.js